export default "__VITE_ASSET__XLvaGoW6__"